import React from 'react';
import * as Sentry from '@sentry/react';
import { Box, Button, Alert, AlertTitle } from '@mui/material';

// Environment detection helper
const isDevelopment = process.env.NODE_ENV === 'development';

// Development fallback component - shows detailed error UI with MUI components
const DevelopmentFallback: Sentry.FallbackRender = errorData => {
  const { resetError } = errorData;

  return (
    <Alert
      severity="error"
      sx={{
        my: 2,
        borderRadius: 2,
        border: 1,
        borderColor: 'borderColors.primary',
      }}
      square={false}
    >
      <AlertTitle>An error occurred loading this action</AlertTitle>
      <Box sx={{ mb: 2 }}>
        This message is only visible during development. Check the console for more detailed error
        information.
      </Box>
      <Button
        variant="contained"
        color="error"
        size="small"
        onClick={resetError}
        fullWidth
        sx={{ alignSelf: 'flex-start' }}
      >
        Reload Component Tree
      </Button>
    </Alert>
  );
};

// Production fallback component - auto-recovers with minimal UI
const ProductionFallback: Sentry.FallbackRender = errorData => {
  return <></>; // No UI in production.
};

// Create environment-specific fallback handler
export const createActionCardErrorFallback = (): Sentry.FallbackRender => {
  return isDevelopment ? DevelopmentFallback : ProductionFallback;
};

// Default export of the fallback renderer for easy imports
export const ActionCardErrorFallback = createActionCardErrorFallback();
